var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"message-audio",class:[
    !_setup.isPC && 'message-audio-h5',
    _setup.message.flow === 'out' && 'reserve',
    _setup.message.hasRiskContent && 'disable',
  ],on:{"click":function($event){$event.stopPropagation();return _setup.play.apply(null, arguments)}}},[_c(_setup.Icon,{staticClass:"icon",attrs:{"file":_setup.audioIcon}}),_c('label',{staticClass:"time",style:({ width: `${_setup.data.second * 10 + 20}px` })},[_vm._v(" "+_vm._s(_setup.data.second || 1)+" \" ")]),_c('audio',{ref:"audioRef",attrs:{"src":_setup.data.url}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }